<template>
  <div class="comment-content">
    <div v-for="item in comment_list"
         :key="item.id">
      <FlashbaseCommentContent :item="item.item"
                               :data="item.comment"
                               :is-order="false"
                               :is-custom="false"
                               :is-admin="false"
                               @append-show="append(item)"
                               @submit-reply="reply"
                               @edit="edit(item)">
        <template #appendComment>
          <FlashbaseCommentAppend :append-list="commentDate(item.comment)"
                                  :created-at="item.comment[0].createdAt"></FlashbaseCommentAppend>
          <FlashbaseCommentReply :is-detail="false"
                                 :is-custom="false"
                                 :is-admin="false"
                                 :comment-id="item.comment[0].id"
                                 :user-id="item.comment[0].user.id"
                                 :append-list="item.comment[0].commentReplys"
                                 :created-at="item.comment[0].createdAt"
                                 @submit-reply="submitReply"></FlashbaseCommentReply>
        </template>
      </FlashbaseCommentContent>

      <!-- <comment-reply :a></comment-reply> -->
    </div>
    <div class="page-content">
      <APagination v-model:current="paginationCurrent"
                   v-model:pageSize="paginationSize"
                   :page-size-options="paginationSizeOptions"
                   :show-size-changer="true"
                   :total="paginationTotal"
                   @change="changePagination" />
    </div>
    <a-modal v-model:visible="is_append"
             :title="$t('Comment.Comment.append')"
             width="50%"
             :footer="null">
      <div class="comment-item">
        <FlashbaseCommentItem :item="append_data"
                              :is-edit="false"
                              :is-divider="false"
                              :is-append="true"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
    <a-modal v-model:visible="is_edit"
             :title="$t('Comment.Comment.edit')"
             width="50%"
             :footer="null">
      <div>
        <FlashbaseCommentItem :item="edit_data"
                              :is-edit="true"
                              :is-divider="false"
                              :is-append="false"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
  </div>

  <div v-if="comment_list"
       class="comment-content">
    <div class="title">
      <left-square-outlined @click="onGoBack" />
      <h4>{{ $t('Comment.CommentDetail.title') }}</h4>
    </div>
    <div style="display: flex;">
      <div v-if="query.from == 'custom'"
           class="comment-gravatar">
        <img :src="gravatar(comment_list.user)"
             class="comment-img" />
      </div>
      <div style="flex:1">
        <FlashbaseCommentContent :item="comment_list.item"
                                 :data="comment_list.comment"
                                 :is-order="false"
                                 :is-custom="query.from == 'custom'"
                                 :is-admin="false"
                                 @append-show="append"
                                 @submit-reply="reply"
                                 @edit="edit">
          <template #appendComment>
            <FlashbaseCommentAppend :append-list="commentDate(comment_list.comment)"
                                    :created-at="comment_list.comment[0].createdAt"></FlashbaseCommentAppend>
            <FlashbaseCommentReply :is-detail="true"
                                   :is-custom="false"
                                   :is-admin="false"
                                   :comment-id="comment_list.comment[0].id"
                                   :user-id="comment_list.comment[0].user.id"
                                   :append-list="comment_list.comment[0].commentReplys"
                                   :created-at="comment_list.comment[0].createdAt"
                                   @submit-reply="submitReply"></FlashbaseCommentReply>
          </template>
        </FlashbaseCommentContent>
      </div>
    </div>
    <a-modal v-model:visible="is_append"
             :title="$t('Comment.CommentDetail.append')"
             width="50%"
             :footer="null">
      <div class="FlashbaseCommentItem">
        <FlashbaseCommentItem :item="comment_list"
                              :is-edit="false"
                              :is-divider="false"
                              :is-append="true"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
    <a-modal v-model:visible="is_edit"
             :title="$t('Comment.CommentDetail.edit')"
             width="50%"
             :footer="null">
      <div>
        <FlashbaseCommentItem :item="comment_list"
                              :is-edit="true"
                              :is-divider="false"
                              :is-append="false"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue"
import { APagination } from '@iota-cn/ui-components'
import { sortBy } from "../../custom-spus/utils"
import { fetchComment, getCommentDetail } from "../api/index"
import { toUrl } from "@/utils"
import default_avatar from '../../shop/assets/default_avatar.png'
import { useRoute, useRouter } from "vue-router"

// const order_detail = ref()
const comment_list = ref()
const query = useRoute().query
const router = useRouter()
const route = useRoute()

onMounted(async () => {
  await init()
})

const paginationTotal = ref(0)
const paginationSize = ref(5)
const paginationSizeOptions = ref([5, 10, 20, 50])
const paginationCurrent = ref(1)
const offset = ref<number>(0)

const init = async () => {
  const data = {
    limit: paginationSize.value,
    offset: offset.value
  }
  await fetchComment(data).then((res: any) => {
    paginationTotal.value = res.count
    // order_detail.value = res
    comment_list.value = []
    res.data.forEach((r: any) => {
      comment_list.value.push({
        comment: [r],
        item: r.item,
        user: r.user
      })
    })
  })
  is_append.value = false
  is_edit.value = false
}

const changePagination = async (page: number, pageSize: number) => {
  paginationSize.value = pageSize
  paginationCurrent.value = page
  offset.value = (page - 1) * pageSize
  await init()
}

const createSuccess = async () => {
  await init()
}

const reply = async () => {
  await init()
}

const submitReply = async () => {
  await init()
}

const is_append = ref<boolean>(false)
const append_data = ref<any>()
const append = (value: any) => {
  is_append.value = true
  append_data.value = {
    comments: value.comment,
    ...value.item
  }
}

const edit_data = ref<any>()
const is_edit = ref<boolean>(false)
const edit = (value: any) => {
  is_edit.value = true
  edit_data.value = {
    comments: value.comment,
    ...value.item
  }
}

const commentDate = (data: any) => {
  // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
  return data[0].children ? data[0].children.sort(sortBy('createdAt', true)) : []
}

const gravatar = (user: any) => {
  return toUrl(user.gravatar) || default_avatar
}

const onGoBack = () => {
  // router.push(`/console/accounts/comment`)
  router.go(-1)
}

const detailInit = async () => {
  const id = route.params.id
  await getCommentDetail(id).then((res: any) => {
    const data = res[0]
    // order_detail.value = res
    comment_list.value = {
      comment: [data],
      item: data.item,
      user: data.user
    }
  })
  is_append.value = false
  is_edit.value = false
}

onMounted(async () => {
  await detailInit()
})
</script>

<style scoped lang="less">
.comment-content {
  padding: 20px;
  height: 100%;
  overflow: scroll;
  padding-top: 0;

  .title {
    position: sticky;
    top: 0;
    display: flex;
    height: 55px;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 0;
    margin-bottom: 20px;
    background: #fff;
    z-index: 1000;

    h4 {
      margin: 0 0 0 10px;
    }
  }

  .FlashbaseCommentItem {
    margin-top: 20px;
    padding: 20px;
    background: #F6F6F6;
  }

  .comment-gravatar {
    margin-right: 15px;

    .comment-img {
      width: 64px;
      height: 64px;
    }
  }
}
</style>
